import { createReducer, on } from '@ngrx/store';
import { CheckoutState } from './checkout.state';
import { ICheckout } from '../model/checkout.model';
import { checkoutActions } from './checkout.actions';
import { IPayment } from '../model/payment.model';
import { shoppingCartActions } from '../../shoppingCart/store/shoppingCart.actions';

export const initialCheckoutState: CheckoutState = {
  checkout: {} as ICheckout,
  enrolledCourseId: ''
};
 
export const checkoutReducer = createReducer(
    initialCheckoutState,

    on( checkoutActions.enrollSuccess, (state , { courseId }) => ({ 
      ...state, 
      enrolledCourseId: courseId 
    })),

    // on( checkoutActions.removeFromCheckoutSuccess, (state , { checkout }) => ({ 
    //   ...state, 
    //   checkout: checkout 
    // })),

    // on( checkoutActions.updateCheckoutQuantitySuccess, (state , { checkout }) => ({ 
    //   ...state, 
    //   checkout: checkout 
    // }))
);  